<template>
  <div id="banner_left_section" class="flex flex-row items-center gap-4">
    <div class="flex flex-col pr-3 truncate max-w-[200px]">
      <a-tooltip :title="campaignDetails?.name || 'New Campaign'" placement="top">
        <span class="text-sm font-semibold truncate">{{
          campaignDetails?.name || "New Campaign"
        }}</span>
      </a-tooltip>
      <span class="text-xs font-medium">{{
        isCampaignActive ? elapsedTime : campaignDetails?.formated_duration
      }}</span>
    </div>

    <EditCallCampaignModal v-if="showSettings" source="banner_left_section" />

    <ViewDetailsDropdown source="banner_left_section" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from "vue";
import store from "@/src/store/index.js";
import { callCampaignStatuses } from "@/src/constants/callConstants.js";
import EditCallCampaignModal from "@/src/views/calls/call_campaigns/EditCallCampaignModal.vue";
import ViewDetailsDropdown from "@/src/views/calls/call_campaigns/campaign_banner/ViewDetailsDropdown.vue";

let timer;
const elapsedSeconds = ref(0);
const elapsedTime = ref("00:00");

const campaignDetails = computed(
  () => store.getters["callsCampaign/campaignDetails"],
);

const isCampaignActive = computed(
  () => store.getters["callsCampaign/isCurrentCampaign"],
);

const callActive = computed(() => store.getters["calls/isCallConnected"]);

const showSettings = computed(
  () =>
    !(
      store.getters["callsCampaign/campaignStatus"] ===
        callCampaignStatuses.COMPLETED ||
      store.getters["callsCampaign/campaignStatus"] ===
        callCampaignStatuses.ENDED
    ),
);

const updateTimer = () => {
  elapsedSeconds.value += 1;
  const minutes = Math.floor(elapsedSeconds.value / 60);
  const seconds = elapsedSeconds.value % 60;
  elapsedTime.value = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};

watch(callActive, (newValue) => {
  if (newValue) {
    timer = setInterval(updateTimer, 1000);
  } else {
    clearInterval(timer);
  }
});

watch(isCampaignActive, (newValue) => {
  if (!newValue) {
    clearInterval(timer);
    elapsedSeconds.value = 0;
    elapsedTime.value = "00:00";
  }
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>
